import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatButton } from '@angular/material/button';

export interface DialogData {
    deleteTemplate: boolean;
}

@Component({
    selector: 'delete-template-dialog',
    templateUrl: 'delete_template_dialog.component.html',
    styleUrls: ['delete_template_dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class DeleteTemplateDialog {

    constructor(
        public dialogRef: MatDialogRef<DeleteTemplateDialog>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

    onClick(deleteTemplate: boolean): void {
        this.data.deleteTemplate = deleteTemplate;
        this.dialogRef.close();
    }
}
